export class NotificationData {

    type?: string
    icon?: string = 'tabler_solid:info-triangle'
    isImage?: boolean = false
    status?: 'warning' | 'danger' | 'edit' | 'info' | 'success' = 'info'
    title: string
    message: string
    sound?:boolean = true
    withDate?: boolean = true
    createdAt?: Date = new Date()
    timeToClose?: number = 3000
    buttons?: any
    params?:any

    constructor({
        type, icon = 'tabler_solid:info-triangle' , isImage = false, status ='info', title, message, sound = true, withDate = true, createdAt = new Date(), timeToClose = 3000, buttons, params
    }: {
        type?,
        icon?: string, 
        isImage?:boolean, 
        status?:'warning' | 'danger' | 'edit' | 'info' | 'success', 
        title:string, 
        message:string, 
        sound?: boolean, 
        withDate?: boolean, 
        createdAt?: Date, 
        timeToClose?: number, 
        buttons?:any, 
        params?:any
    }) {
        this.type = type
        switch(status) {
            case 'success': this.icon = 'tabler_outline:check'
            break
            case 'info': this.icon = 'tabler_outline:check'
            break
            case 'edit': this.icon = 'tabler_outline:check'
            break
            case 'warning': this.icon = 'tabler_solid:info-triangle'
            break
            case 'danger': this.icon = 'tabler_solid:alert-circle'
            break
            default: this.icon = 'tabler_solid:info-triangle'
        }
        this.isImage = isImage
        this.status = status
        this.title = title
        this.message = message
        this.sound = sound
        this.withDate = withDate
        this.createdAt = createdAt
        this.timeToClose = timeToClose
        this.buttons = buttons
        this.params = params
    }
}